import { useState } from "react";
import {
    AppBar,
    Avatar,
    Badge,
    Box,
    IconButton,
    InputBase,
    Menu,
    MenuItem,
    Toolbar,
    Tooltip,
    Typography
} from "@mui/material";

import {
    Menu as MenuIcon,
    Notifications,
    Search,
    AccountCircle
} from "@mui/icons-material";

import useAuth from "../../hooks/useAuth";

const drawerWidth = 250;

export default function Topbar({

    handleDrawerToggle

}) {

    const { user, logout } = useAuth();

    const [anchorEl, setAnchorEl] = useState(null);

    const open = Boolean(anchorEl);

    const handleMenu = (event) => {

        setAnchorEl(event.currentTarget);

    };

    const handleClose = () => {

        setAnchorEl(null);

    };

    const handleLogout = () => {

        handleClose();

        logout();

    };

    return (

        <AppBar

            position="fixed"

            elevation={1}

            color="inherit"

            sx={{

                width: {

                    md: `calc(100% - ${drawerWidth}px)`

                },

                ml: {

                    md: `${drawerWidth}px`

                },

                borderBottom: "1px solid #E0E0E0"

            }}

        >

            <Toolbar>

                {/* Mobile Menu */}

                <IconButton

                    color="inherit"

                    edge="start"

                    onClick={handleDrawerToggle}

                    sx={{

                        mr: 2,

                        display: {

                            md: "none"

                        }

                    }}

                >

                    <MenuIcon />

                </IconButton>

                {/* Title */}

                <Typography

                    variant="h6"

                    sx={{

                        fontWeight: 600,

                        color: "#1976d2"

                    }}

                >

                    U2USYSTEMS Knowledge Hub

                </Typography>

                <Box sx={{ flexGrow: 1 }} />

                {/* Search */}

                <Box

                    sx={{

                        display: "flex",

                        alignItems: "center",

                        background: "#F5F5F5",

                        borderRadius: 2,

                        px: 2,

                        py: 0.5,

                        width: 320,

                        mr: 3

                    }}

                >

                    <Search

                        sx={{

                            color: "gray",

                            mr: 1

                        }}

                    />

                    <InputBase

                        placeholder="Search knowledge..."

                        fullWidth

                    />

                </Box>

                {/* Notifications */}

                <Tooltip title="Notifications">

                    <IconButton>

                        <Badge

                            badgeContent={3}

                            color="error"

                        >

                            <Notifications />

                        </Badge>

                    </IconButton>

                </Tooltip>

                {/* User */}

                <Tooltip title="Account">

                    <IconButton

                        sx={{ ml: 2 }}

                        onClick={handleMenu}

                    >

                        <Avatar>

                            {user?.name?.charAt(0)}

                        </Avatar>

                    </IconButton>

                </Tooltip>

                <Menu

                    anchorEl={anchorEl}

                    open={open}

                    onClose={handleClose}

                >

                    <MenuItem disabled>

                        <AccountCircle

                            sx={{ mr: 1 }}

                        />

                        {user?.name}

                    </MenuItem>

                    <MenuItem disabled>

                        {user?.email}

                    </MenuItem>

                    <MenuItem onClick={handleLogout}>

                        Logout

                    </MenuItem>

                </Menu>

            </Toolbar>

        </AppBar>

    );

}